/**
 * Optimistic shell for protected routes.
 *
 * Rendered immediately when a user with a cached session opens /app while
 * `getMe()` verifies email_verified in the background, and while any lazy
 * page chunk under ProtectedRoute is still downloading. Neutral layout
 * (header bar + body pulse) so it works for MainPage / CanvasPage / billing
 * alike without looking wrong for any one of them.
 */
export default function AppShell() {
  return (
    <div className="min-h-screen bg-surface-base" data-testid="app-shell">
      <div className="h-16 border-b border-border bg-white px-6 flex items-center justify-between">
        <div className="h-7 w-28 bg-gray-100 rounded animate-pulse" />
        <div className="flex items-center gap-3">
          <div className="h-8 w-20 bg-gray-100 rounded-full animate-pulse" />
          <div className="h-9 w-9 bg-gray-100 rounded-full animate-pulse" />
        </div>
      </div>
      <div className="max-w-[1200px] mx-auto px-[60px] max-md:px-6 pt-10">
        <div className="h-8 w-64 bg-gray-100 rounded animate-pulse mb-6" />
        <div className="h-48 w-full rounded-2xl border border-border bg-white p-5">
          <div className="h-full w-full bg-gray-50 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
}
